import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const ServiceTypesRedux = createActions(
  {
  },
  {
    prefix: 'SERVICE_TYPES_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = ServiceTypesRedux
export const ServiceTypesTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})


export const reducer = createReducer(
  INITIAL_STATE, {
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ServiceTypesRedux.js